import React, { useState, useContext } from "react";
import Carousel from "react-bootstrap/Carousel";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faImages } from "@fortawesome/free-solid-svg-icons";
import { LoginContext } from "../context/LoginContext";
import "./css/Products.css";

const Slider = (props) => {
  const [show, setShow] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  const [showDeleteResult, setShowDeleteResult] = useState(false);

  const [src, setSrc] = useState("");

  const [resultMsg, setResultMsg] = useState("");

  const [result, setResult] = useState(false);

  const login = useContext(LoginContext);

  const deleteImg = () => {
    const formData = new FormData();
    formData.append("delete_image", 1);
    formData.append("barcode", props.barcode);
    formData.append("vitrinCode", props.vitrinCode);
    formData.append("file", src);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setResultMsg(data.data);
        setResult(data.result);
        setShowDeleteResult(true);
      });
  };

  const showDeleteAlert = (src) => {
    setSrc(src);
    setShowDelete(true);
  };

  const closeResult = () => {
    if (result) {
      window.location.reload(false);
    } else {
      setShowDeleteResult(false);
    }
  };

  if (props.type === "products") {
    return (
      <div>
        {props.num > 0 ? (
          <div className="img">
            <Carousel controls={true} interval={null}>
              {props.num > 0
                ? props.images.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 card-border"
                        src={item}
                        alt={item}
                        onClick={() => {
                          window.open(item, "_blank");
                        }}
                      />
                      {login.loginState && login.userInfo.isModir ? (
                        <Carousel.Caption>
                          <button
                            className="btn btn-danger"
                            onClick={() => {
                              showDeleteAlert(item);
                            }}
                          >
                            حذف
                          </button>
                        </Carousel.Caption>
                      ) : null}
                    </Carousel.Item>
                  ))
                : null}
            </Carousel>
            {/* <img
              onClick={() => {
                setShow(true);
              }}
              className="d-block w-100"
              src={props.images[0]}
              alt="Third slide"
            />
            <div className="bottom-left">
              <FontAwesomeIcon icon={faImages} /> {props.num}
            </div> */}
          </div>
        ) : null}
        <Modal
          show={show}
          onHide={() => {
            setShow(false);
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header className="rtl">
            <FontAwesomeIcon
              icon={faTimes}
              color="gray"
              size="lg"
              onClick={() => {
                setShow(false);
              }}
            />
          </Modal.Header>
          <Modal.Body>
            <Carousel controls={true} interval={null}>
              {props.num > 0
                ? props.images.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img className="d-block w-100" src={item} alt={item} />
                      {login.loginState && login.userInfo.isModir ? (
                        <Carousel.Caption>
                          <button
                            className="btn btn-danger"
                            onClick={() => {
                              showDeleteAlert(item);
                            }}
                          >
                            حذف
                          </button>
                        </Carousel.Caption>
                      ) : null}
                    </Carousel.Item>
                  ))
                : null}
            </Carousel>
          </Modal.Body>
        </Modal>

        <Modal
          show={showDelete}
          onHide={() => {
            setShowDelete(false);
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header className="rtl">
            <FontAwesomeIcon
              icon={faTimes}
              color="gray"
              size="lg"
              onClick={() => {
                setShowDelete(false);
              }}
            />
          </Modal.Header>
          <Modal.Body>
            <p>از حذف تصویر اطمینان دارید؟</p>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-danger"
              onClick={() => {
                deleteImg();
              }}
            >
              حذف
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                setShowDelete(false);
              }}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showDeleteResult}
          onHide={() => {
            closeResult();
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header className="rtl">
            <FontAwesomeIcon
              icon={faTimes}
              color="gray"
              size="lg"
              onClick={() => {
                closeResult();
              }}
            />
          </Modal.Header>
          <Modal.Body>
            <p>{resultMsg}</p>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-primary"
              onClick={() => {
                closeResult();
              }}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  } else {
    return (
      <Carousel controls={true} interval={null}>
        {props.num > 0
          ? props.images.map((item, index) => (
              <Carousel.Item key={index}>
                <img className="slider d-block w-100" src={item} alt={item} />
                {login.loginState && login.userInfo.isModir ? (
                  <Carousel.Caption>
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        showDeleteAlert(item);
                      }}
                    >
                      حذف
                    </button>
                  </Carousel.Caption>
                ) : null}
              </Carousel.Item>
            ))
          : null}
      </Carousel>
    );
  }
};

export default Slider;
